import React from 'react';
import {MasterLayout} from 'layout';
import {ChinhSuaCuocThanhTra} from 'modules/thanh-tra';

export default class ChinhSuaCuocThanhTraDotXuatPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ChinhSuaCuocThanhTra check={this.props.location} params={this.props.params} type='DOT_XUAT'/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/ChinhSuaCuocThanhTraDotXuatPage.jsx